import { atom } from 'jotai';
import { pageStateVM, editStateVM, modelVM } from './groups_create_view_models';
import { AdminGroupsModel, EditStateGroup, GroupsCreatePageState } from './groups_create_types';

export const pageStateGroupsCreateAtom = atom<GroupsCreatePageState>(pageStateVM());
export const editStateGroupsCreateAtom = atom<EditStateGroup>(editStateVM());
export const createModelGroupAtom = atom<AdminGroupsModel>(modelVM());
export const readOnlycreateModelGroupAtom = atom<AdminGroupsModel>(modelVM());
